import { useEffect } from "react";
import Loader from "../../components/atoms/Loader";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../../hocs/enhanceAuthenticatedPage";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import { useQueryError } from "../../hooks/http/useQueryError";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsStudyRecordSkillsEditPage from "./SectionsSettingsStudyRecordSkillsEditPage";
import { useFetchSkill } from "./useFetchSkill";

interface Params {
  skillId: string;
}

type Props = WithRouterProps<Params> &
  AuthenticatedPageCallbacks &
  AuthenticatedPageProps &
  OutletContextProps & {
    section: SectionInterface;
  };

const Page = (props: Props) => {
  useEffect(() => {
    props.setActiveMenu("skills");
  }, []);

  const {
    data: skill,
    error,
    isPending,
  } = useFetchSkill({
    sectionId: props.section.id,
    skillId: props.params.skillId,
  });
  useQueryError(error);

  if (isPending || !skill) {
    return <Loader loading />;
  }

  return <SectionsSettingsStudyRecordSkillsEditPage {...props} skill={skill} />;
};

const pageInfo = {
  title: "アシスタント",
};

export default enhanceSectionsSettingsPage(Page, pageInfo, ["assistant:index"]);
